var render, staticRenderFns
import script from "./DraggableElTable.vue?vue&type=script&lang=js&"
export * from "./DraggableElTable.vue?vue&type=script&lang=js&"
import style0 from "./DraggableElTable.vue?vue&type=style&index=0&id=dbffc122&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbffc122",
  null
  
)

export default component.exports